import { createRouter, createWebHistory } from "vue-router"
import layout from "@/layouts/layout.vue"

const main = [
  {
    path: "/",
    name: "default",
    redirect: "/autocall",
  },
  {
    path: "/autocall",
    name: "autocall",
    component: () => import("@/views/autocall.vue"),
  },
  {
    path: "/complete",
    name: "complete",
    component: () => import("@/views/complete.vue"),
  },
  {
    path: "/direct",
    name: "direct",
    component: () => import("@/views/complete.vue"),
  },
  {
    path: "/message",
    name: "message",
    component: () => import("@/views/complete.vue"),
  },
  {
    path: "/reconn",
    name: "reconn",
    component: () => import("@/views/reconn.vue"),
  },
  {
    path: "/seeyou",
    name: "seeyou",
    component: () => import("@/views/seeyou.vue"),
  },
  {
    path: "/seeyousub",
    name: "seeyousub",
    component: () => import("@/views/seeyou.vue"),
  },
  {
    path: "/404",
    name: "page404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "/useinfo",
    name: "useinfo",
    component: () => import("@/views/useinfo.vue"),
  },
  { path: "/:pathMatch(.*)", redirect: "/404" },
]

const routes = [
  {
    path: "/",
    component: layout,
    children: main,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
